import styled from "styled-components";

export const ContainerCenter = styled.div`
  height: 100%;
  width: 100%;
  background-color: #eff1f5;
`;

export const TopDiv = styled.div`
  display: flex;
  min-height: 560px;
  min-width: 1280px;

  height: 100vh;
  width: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
`;

export const ContainerCenterInside = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: calc(100vh - 4.5rem); // 4.5rem = topBar Size
  justify-content: space-evenly;
  align-items: center;
`;

export const Line1 = styled.div`
  height: 47%; // 50%
  width: 100%;
  display: flex;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    pointer-events: none;
    opacity: 0.5;
    background-color: #f0f0f0; // Apply a light grey overlay
    color: #808080; // Grey out text
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1rem;
    }
  `}
`;
export const Line2 = styled.div`
  height: 40.8%; //40%
  width: 100%;
  display: flex;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    pointer-events: none;
    opacity: 0.5;
    background-color: #f0f0f0; // Apply a light grey overlay
    color: #808080; // Grey out text
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1rem;
    }
  `}
`;

export const Block1 = styled.div`
  height: 90%;
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #585e66;
  border-radius: 10px;
  position relative;
`;

export const Block2 = styled.div`
  height: 90%;
  width: 55%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Block3 = styled.div`
  height: 100%;
  width: 40%;

  margin-left: 1.5%;
`;

export const Block4 = styled.div`
  height: 100%;
  width: 25.7%;

  margin-left: 2.5%;
`;
export const Block5 = styled.div`
  height: 100%;
  width: 67.2%;

  margin-left: 1.5%;
`;
